import React, { Component } from 'react';
import AuthService from '../../utils/AuthService';
import Page from '../Page';
import PageSection from '../PageSection';
import Input from '../Input';
import Popup from '../Popup';

class Login extends Component {
	constructor(props) {
		super(props);

		this.Auth = new AuthService();

		this.state = {
			email: "",
			password: ""
		};

		this.handleInputChange = this.handleInputChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);

		this.showMessage = this.showMessage.bind(this);
		this.hideMessage = this.hideMessage.bind(this);
		this.loadingButton = this.loadingButton.bind(this);
		this.removeLoadingButton = this.removeLoadingButton.bind(this);
	}

	componentWillMount(){
		if(this.Auth.loggedIn()) {
			this.props.history.replace('/');
		}
	}

	handleInputChange(event) {
		const target = event.target;
		const value = target.type === 'checkbox' ? target.checked : target.value;
		const name = target.name;

		this.setState({
			[name]: value
		});
	}

	showMessage(body, title, actionButtons) {
		var messageTitle = title || ' ',
			messageActionButtons = actionButtons || <button className="pp-button" onClick={this.hideMessage}>Close</button>;

		this.setState({
			message: {
				body: body,
				title: messageTitle,
				actionButtons: messageActionButtons
			}
		});
	}

	hideMessage() {
		this.setState({
			message: false
		});
	}

	loadingButton(target) {
		target.disabled = true;
		target.classList.add('pp-loading');
	}

	removeLoadingButton(target) {
		target.disabled = false;
		target.classList.remove('pp-loading');
	}

	handleSubmit(event) {
		const data = new FormData(event.target);
		var target = document.getElementById('login-button');

		this.loadingButton(target);

		this.Auth.login(data)
			.then((result) => {
				console.log(result);
				this.removeLoadingButton(target);
				if(result.success) {
					this.props.history.push('/');
				} else {
					if(result.messages) {
						this.showMessage(result.messages.join("\n"));
					}
				}
			},
			(error) => {
				console.log(error);
				this.removeLoadingButton(target);
				this.showMessage('Something went wrong. Please try again later.');
			}
		);
		event.preventDefault();
	}

	render() {

		const { message } = this.state;

		return (
			<Page pageClass="pp-login-page">

				{message &&
					<Popup body={message.body} title={message.title} actionButtons={message.actionButtons} />
				}

				<PageSection className="pp-user-flow">

					<form id="login" className="pp-form-wrapper" onSubmit={this.handleSubmit}>

						<div className="pp-form-row">
							<Input
								type="text"
								htmlName="user_email"
								label="Email Address"
								placeholderText="Email"
								onChange={this.handleInputChange}
								value={this.state.user_email}
							/>
						</div>
						<div className="pp-form-row">
							<Input
								type="password"
								htmlName="user_password"
								label="Password"
								placeholderText="Password"
								onChange={this.handleInputChange}
								value={this.state.user_password}
							/>
						</div>

						<div className="pp-action-buttons">
							<button type="submit" id="login-button" className="pp-button">Log In</button>
							<p className="pp-instruction">or</p>
							<a href="/register" className="pp-register-button">Register</a>
							<a href="/password-reset" className="pp-forgot-password-button">Forgot Your Password?</a>
						</div>
					</form>

				</PageSection>

			</Page>
		);
	}
}

export default Login;



// WEBPACK FOOTER //
// ./src/components/pages/Login.js